import React  from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';

import Everest from "../media/Investments/Banking/Everest Bank.png"
import Garima from "../media/Investments/Banking/Garima Bikas Bank.png";
import Kamana from "../media/Investments/Banking/Kamana Sewa Bikas Bank.png";
import Sanima from "../media/Investments/Banking/SANIMA Bank.png";
import Nabil from "../media/Investments/Banking/NABIL Bank.png";
import StandardChartered from "../media/Investments/Banking/Standard Chartered Bank.png";

import ICFC from "../media/Investments/Finance/ICFC Finance.png"
import manjushree from "../media/Investments/Finance/Manjushree Finance.png";
import multipurpose from "../media/Investments/Finance/Multi-Purpose Finance.png";

import chandragiri from "../media/Investments/Hotels/Chandragiri Hills.png";
import cityhotel from "../media/Investments/Hotels/CITY Hotel.png";
import siddhartha from "../media/Investments/Hotels/Siddhartha Cable Car.png";
import soaltee from "../media/Investments/Hotels/Soaltee Hotel Limited.png";

import chilime from "../media/Investments/Hydropower/Chilime Hydropower.jpg";
import kalka from "../media/Investments/Hydropower/Kalika Power.png";
import mandu from "../media/Investments/Hydropower/Mandu-hydropower-1.png";
import modi from "../media/Investments/Hydropower/Modi Energy Limited.png";
import mountain from "../media/Investments/Hydropower/Mountain Energy.png";

import lifeinsurance from "../media/Investments/Insurance/Life Insurance Co. Nepal.png";
import national from "../media/Investments/Insurance/National Life Insurance.png";
import nlic from "../media/Investments/Insurance/NLIC.png";
import surya from "../media/Investments/Insurance/Surya Jyoti Life Insurance.png";

import himalayan from '../media/Investments/Manufacturing/Himalayan Distillery.png';
import shivam from '../media/Investments/Manufacturing/Shivam Cement.png';

import chhimek from '../media/Investments/Microfinance/Chhimek Bikas Laghubitta.png';
import deprosc from '../media/Investments/Microfinance/Deprosc Laghubitta.png';
import jeevan from '../media/Investments/Microfinance/Jeevan Bikash Laghubitta.png';
import mahila from '../media/Investments/Microfinance/Mahila Laghubitta.png';
import nesdo from '../media/Investments/Microfinance/NESDO Sambridha.png';

import himalayaninsurance from '../media/Investments/Others/himalayan-reinsurance.png';
import nepalreinsurace from '../media/Investments/Others/Nepal Re-Insurance.png';
import nepaltelecom from '../media/Investments/Others/Nepal Telecom.png';




const banking = [Everest, Sanima, Nabil, StandardChartered,Garima, Kamana];
const finance = [ICFC, manjushree, multipurpose];
const hotels = [chandragiri, cityhotel, soaltee];
const hydropower = [chilime, kalka, mandu, modi, mountain];
const insurance = [lifeinsurance, national, nlic, surya];
const manufacturing = [himalayan, shivam];
const microfinance = [chhimek, deprosc, mahila, nesdo, jeevan ];
const others = [himalayaninsurance, nepalreinsurace, nepaltelecom];

const Portfolio = () => {
    const navigate = useNavigate();
    const goBack = () => {
      navigate(-1);
    }

    
    return(
        <div className="management-team-container">
        <div className="content">
        <p style={{display: 'flex'}}>
            <ArrowLeftOutlined  onClick={goBack}></ArrowLeftOutlined>Go back
            </p>
             <h1>Our Portfolios</h1>
            <h2>Banking Sector</h2>
            {banking.map((image, i) => (
                <img src={image} alt={i + "image"} height={50} style={{margin: 2}}/>
            ))}
            <h2>Finance Sector</h2>
            {finance.map((image, i) => (
                <img src={image} alt={i + "image"} height={50} style={{margin: 2}}/>
            ))}
            <h2>Hotels & Tourism Sectors</h2>
            {hotels.map((image, i) => (
                <img src={image} alt={i + "image"} height={50} style={{margin: 2}}/>
            ))}
            <h2>Hydropower Sectors</h2>
            {hydropower.map((image, i) => (
                <img src={image} alt={i + "image"} height={50} style={{margin: 2}}/>
            ))}
             <h2>Insurance Sectors</h2>
            {insurance.map((image, i) => (
                <img src={image} alt={i + "image"} height={50} style={{margin: 2}}/>
            ))}
             <h2>Manufacturing Sectors</h2>
            {manufacturing.map((image, i) => (
                <img src={image} alt={i + "image"} height={50} style={{margin: 2}}/>
            ))}
             <h2>Microfinance Sectors</h2>
            {microfinance.map((image, i) => (
                <img src={image} alt={i + "image"} height={50} style={{margin: 2}}/>
            ))}
             <h2>Other Sectors</h2>
            {others.map((image, i) => (
                <img src={image} alt={i + "image"} height={50} style={{margin: 2}}/>
            ))}
        </div>
        </div>
    )
}


export default Portfolio;